import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee54fa94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-proportion" }
const _hoisted_2 = { class: "number" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "专利申请总量", -1))
const _hoisted_4 = { class: "number-item" }
const _hoisted_5 = { class: "number" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "创新主体总量", -1))
const _hoisted_7 = { class: "number-item" }
const _hoisted_8 = { class: "number" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "研发人员总量", -1))
const _hoisted_10 = { class: "number-item" }

import { storeToRefs } from 'pinia'
import { useHomeDataStore } from '@/pinia/useHomeDataStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberCpn',
  setup(__props) {

const homeDataStore = useHomeDataStore()
const { data } = storeToRefs(homeDataStore)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_unref(data)?.midNumber.patent)?.toString()), (item, index) => {
          return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_unref(data)?.midNumber.innovate)?.toString()), (item, index) => {
          return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_unref(data)?.midNumber.personnel)?.toString()), (item, index) => {
          return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
        }), 128))
      ])
    ])
  ]))
}
}

})